import React, { Component } from 'react';
import shirt2 from '../assets/shirt2.png';
import black_throw from '../assets/black_throw.png';
import qrworapot from '../assets/qrworapot.png';
import size_chart from '../assets/size_chart.jpg';
import logo2 from '../assets/logo2.png';
import './CSS/Shops.css';

class ShopShirts2 extends Component {
  render() {
    return (
      <div className="ShopShirts ShirtOrder">
        <h1>Thai-Aikikai Shop's Shirts</h1>

        {/* Shirt, size chart, payment QR and order QR, stacked vertically */}
        <div className="shirt-gallery">
          <img className="shop-image" src={shirt2} alt="2026 Thai Aikikai T-shirt" />
          <img className="shop-image size-chart" src={size_chart} alt="T-shirt size chart (inches)" />
          <img className="shop-image shop-qr" src={qrworapot} alt="PromptPay payment QR" />
          <img className="shop-image shop-qr" src={black_throw} alt="Order form QR" />
        </div>

        <h2>2026 THAI AIKIKAI T-SHIRT</h2>

        <div className="shirt-price">PRICE : 450 BAHT</div>

        <br />

        <div>
          <div>
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSfziDjOfBvmqow56XGXIMEeLiIqvhhbzZvRR_ly1-MaTEe5vw/viewform" target="_blank" rel="noopener noreferrer">Click to Order</a>
          </div>
        </div>

        <br />

        <div>Powered by</div>

        <img
          className="logo2"
          src={logo2}
          alt="New Wave Consulting Group"
        />

        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default ShopShirts2;
